import PurchaseOrdersList from './PurcharseOrderList';

export default PurchaseOrdersList;
